"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PageInfo_1 = __importDefault(require("./PageInfo"));
class SalesByProductConnection {
    constructor({ edges, pageInfo }) {
        this.toJSON = () => ({
            edges: this.edges,
            pageInfo: this.pageInfo,
        });
        this.edges = edges;
        this.pageInfo = pageInfo;
    }
}
SalesByProductConnection.fromJSON = (json) => {
    const { edges, pageInfo } = Object.assign({}, json);
    if (!Array.isArray(edges))
        throw new Error('.edges must be an array');
    const _pageInfo = PageInfo_1.default.fromJSON(pageInfo);
    return new SalesByProductConnection({
        edges,
        pageInfo: _pageInfo,
    });
};
exports.default = SalesByProductConnection;
